import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const MarketplaceAdvanced = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default MarketplaceAdvanced